import React, { useState, useEffect } from 'react'
import { URLS, METODO_PAGAMENTO_BOLETO, METODO_PAGAMENTO_PIX, MODALIDADE_CURADORIA, MODALIDADE_INEDITOS } from '../../constants'
import { Router } from '@reach/router'
import { useGlobal } from '../../contexts/GlobalContext'
import { useModalidade } from '../../contexts/ModalidadeContext'
import { EnderecoProvider } from '../../contexts/EnderecoContext'
import { CartaoCreditoProvider } from '../../contexts/CartaoCreditoContext'
import { BoletoBancarioProvider } from '../../contexts/BoletoBancarioContext'
import { PixProvider } from '../../contexts/PixContext'
import { MODALIDADE } from './constants'
import { string } from 'prop-types'
import { empty } from '../../utils/helpers/helpers'
import { getAssinaturaDoAssociadoPorModalidade } from '../../utils/helpers/helpersAssinatura'

import Modalidade from './Modalidade'
import PlanoRoutes from './Plano/rotas'
import Entrega from './Entrega/Entrega'
import PagamentoCartaoCredito from './PagamentoCartaoCredito/PagamentoCartaoCredito'
import PagamentoBoletoBancarioRoutes from './PagamentoBoletoBancario/rotas'
import PagamentoPixRoutes from './PagamentoPix/rotas'
import LazyComponent from '../../components/LazyComponent/LazyComponent'

export default function Rotas( { modalidadeDaRota } ) {
  const route = modalidadeDaRota === MODALIDADE.CURADORIA ? URLS.CURADORIA : URLS.INEDITOS
  const routePlano = modalidadeDaRota === MODALIDADE.CURADORIA ? URLS.CURADORIA_PLANO : URLS.INEDITOS_PLANO
  const routePagamento = modalidadeDaRota === MODALIDADE.CURADORIA ? URLS.CURADORIA_PAGAMENTO : URLS.INEDITOS_PAGAMENTO
  const routeEntrega = modalidadeDaRota === MODALIDADE.CURADORIA ? URLS.CURADORIA_ENTREGA : URLS.INEDITOS_ENTREGA

  const { fetchAssinaturaPorModalidade } = useModalidade()
  const { dadosGlobaisAssociado, modalidadeURL, setModalidadeURL } = useGlobal()
  const [ metodoPagamento, setMetodoPagamento ] = useState()
  const [ modalidadeId, setModalidadeId ] = useState()

  const getMetodoPagamentoComponent = () => {
    if ( metodoPagamento === METODO_PAGAMENTO_BOLETO.visualizacao ) {
      return PagamentoBoletoBancarioRoutes
    } else if ( metodoPagamento === METODO_PAGAMENTO_PIX.visualizacao ) {
      return PagamentoPixRoutes
    }
    return PagamentoCartaoCredito
  }

  const getMetodoPagamentoContext = () => {
    if ( metodoPagamento === METODO_PAGAMENTO_BOLETO.visualizacao ) {
      return BoletoBancarioProvider
    } else if ( metodoPagamento === METODO_PAGAMENTO_PIX.visualizacao ) {
      return PixProvider
    }

    return CartaoCreditoProvider
  }

  useEffect( () => {
    if ( modalidadeDaRota === MODALIDADE.CURADORIA ) {
      setModalidadeId( MODALIDADE_CURADORIA.id )
      setModalidadeURL( MODALIDADE_CURADORIA.slug )
    } else {
      setModalidadeId( MODALIDADE_INEDITOS.id )
      setModalidadeURL( MODALIDADE_INEDITOS.slug )
    }
  }, [] )

  useEffect( () => {
    if ( modalidadeId ) {
      fetchAssinaturaPorModalidade( modalidadeId )
    }
  }, [ modalidadeId ] )

  useEffect( () => {
    if ( dadosGlobaisAssociado && modalidadeId ) {
      const assinaturaObtida = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeURL )

      if ( assinaturaObtida ) {
        setMetodoPagamento( assinaturaObtida.metodoPagamento )
      }
    }
  }, [ dadosGlobaisAssociado, modalidadeId ] )

  return (
    <Router>
      <LazyComponent
        Component={ Modalidade }
        currentRoute={ route }
        path="/"
      />

      <LazyComponent
        Component={ PlanoRoutes }
        currentRoute={ routePlano }
        modalidadeDaRota={ modalidadeDaRota }
        path="plano/*"
      />

      { !empty( metodoPagamento ) &&
        <LazyComponent
          Component={ getMetodoPagamentoComponent() }
          Context={ getMetodoPagamentoContext() }
          currentRoute={ routePagamento }
          path="pagamento/*"
        />}
      <LazyComponent
        Component={ Entrega }
        Context={ EnderecoProvider }
        currentRoute={ routeEntrega }
        path="entrega"
      />
    </Router>
  )
}

Rotas.propTypes = {
  'modalidadeDaRota': string.isRequired
}


